import layout1Settings from "app/GullLayout/Layout1/Layout1Settings";
import layout2Settings from "app/GullLayout/Layout2/Layout2Settings";
import axios from "axios";
import config from "config.json";
import { NotificationManager } from "react-notifications";
import { decryptMessage } from "./CommonService";
import httpService from "./httpService";
import { getRoles, getUserPermission } from "./permissionService";
import sessionStorageService from "./sessionStorageService";
import { startConnection, stopConnection } from "./notificationService";
import { normalizeRole } from "helper";
const role = "ADMIN";
// setUser inject from context . navigate inject from react navigation
export const signIn = async (reqData, context) => {
  try {
    context.setIsLoadingLogin(true);
    // debugger;
    const url = `${config.apiUrl}/authenticate/login`;
    const { data: loginResponse } = await httpService.post(url, reqData);
    // console.log(loginResponse);

    const res = loginResponse.authResponse;
    if (res) {
      const authInput = decryptMessage(res);
      const pairs = authInput.split("|").filter(Boolean); // Remove empty parts
      const result = {};

      pairs.forEach((pair) => {
        const [key, value] = pair.split("=");
        result[key] = value;
      });
      // console.log(result);
      otpSendForLogin(result.UserName, context);
    } else {
      NotificationManager.error(loginResponse.message, "Error");
      context.setIsLoadingLogin(false);
    }
  } catch (error) {
    let errorData = error.response.data.message;
    NotificationManager.error(errorData, "Error");
    context.setIsLoadingLogin(false);
  }
};
export const otpSendForLogin = async (reqData, context) => {
  try {
    const url = `${config.apiUrl}/authenticate/send-sms-otp`;
    const { data: smsResponse } = await httpService.post(url, {
      username: reqData,
    });
    // const { data: smsResponse } = await api.post(API_URLS.SEND_OTP, {});
    if (smsResponse?.status == "Success") {
      context.setIsLoggedInOtp(true);

      NotificationManager.success(smsResponse.message, "success");
    } else {
      context.setIsLoggedInOtp(false);
      NotificationManager.error(smsResponse.message, "error");
    }
  } catch (error) {
    let errorData = error?.response?.data?.message;
    NotificationManager.error(errorData, "Error");
  }
  context.setIsLoadingLogin(false); // move this directly here
  // debugger;
};

export const otpVerifyForLogin = async (reqData, navigate, context) => {
  context.setIsLoadingLogin(true);
  try {
    // debugger;
    const url = `${config.apiUrl}/authenticate/verify-sms-otp`;
    const { data: smsResponseVerify } = await httpService.post(url, reqData);
    // console.log(loginResponse);

    if (smsResponseVerify?.status == "Success") {
      const authInput = decryptMessage(smsResponseVerify.data.otpResponse);
      // console.log(authInput);
      const pairs = authInput.split("|").filter(Boolean); // Remove empty parts
      const result = {};

      pairs.forEach((pair) => {
        const [key, value] = pair.split("=");
        result[key] = value;
      });
      // console.log(result);

      sessionStorageService.setItem("jwt_token", result.AuthToken);
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + result.AuthToken;
      // context.setUser(user); // Set User In Context API

      // check layout

      context.setLayoutSettings(layout1Settings);

      // debugger;
      if (
        result.Role &&
        result.Role.toLowerCase() !== "distributor" &&
        result.Role.toLowerCase() !== "supplier"
        // &&
        // user.role.toLowerCase() !== "operation"
      ) {
        // debugger;
        const requiredRole = normalizeRole(result.Role);
        const menus = await getUserPermission(requiredRole);
        // console.log(menus.data);
        context.setNavData(menus.data); // Set Menu In Context API
      }
      NotificationManager.success(`Welcome back, ${result.Role}!`, "Success");

      // Redirect to specific dashboard

      if (result.Role && result.Role.toLowerCase() === "distributor") {
        navigate("/distributor/dashboard");
      } else if (result.Role && result.Role.toLowerCase() == "supplier") {
        navigate("/supplier/dashboard");
      } else {
        startConnection();
        navigate("/admin/dashboard");
      }
      // else if (user.role && user.role.toLowerCase() == "operation") {
      //   navigate("/operation/dashboard");
      // }
      context.setIsLoggedInOtp(false);
    } else {
      NotificationManager.error(smsResponseVerify.message, "Error");
    }
  } catch (error) {
    let errorData = error.response.data.message;
    NotificationManager.error(errorData, "Error");
  }
  context.setIsLoadingLogin(false);
};
export const checkIfAlreadyLoggedIn = async (navigate, context) => {
  try {
    const token = sessionStorageService.getItem("jwt_token");
    if (token) {
      const url = `${config.apiUrl}/authenticate/user`;
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      const { data: user } = await httpService.post(url);
      if (user.token) {
        context.setUser(user); // Set User In Context API
        // debugger;
        // const roles = await getRoles();
        // const requiredRole = roles.data.find(
        //   (x) => x.roleName.toLowerCase() == user.role.toLowerCase(),
        // );
        // debugger;
        const requiredRole = normalizeRole(user.role);

        const menus = await getUserPermission(requiredRole);
        context.setNavData(menus.data); // Set Menu In Context API
        NotificationManager.success(
          `Welcome back, ${user.fullName}!`,
          "Success",
        );

        // Redirect to specific dashboard
        if (user.role && user.role.toLowerCase() === "distributor") {
          navigate("/distributor/dashboard");
        } else {
          navigate("/admin/dashboard");
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const restoreSession = async (context) => {
  try {
    const token = sessionStorageService.getItem("jwt_token");
    if (token) {
      const url = `${config.apiUrl}/authenticate/user`;
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      const { data: user } = await httpService.post(url);
      if (user) {
        // debugger;
        context.setUser(user); // Set User In Context API
        // const roles = await getRoles();
        // const requiredRole = roles.data.find(
        //   (x) => x.roleName.toLowerCase() == user.role.toLowerCase(),
        // );
        const requiredRole = normalizeRole(user.role);
        const menus = await getUserPermission(requiredRole);
        context.setNavData(menus.data); // Set Menu In Context API
      }
    }
  } catch (error) {
    console.log(error);
  }
};

export const signOut = (navigate, context) => {
  stopConnection();
  context.setUser({});
  context.setNavData([]);
  sessionStorageService.removeItem("jwt_token");
  delete axios.defaults.headers.common["Authorization"];
  navigate("/signin");
};
